'use strict'

const bindPolygonCreateClick = function ({
  layer = null,
  $ = window.jQuery,
  areaSwal = null,
  fnT = function (key) { return String(key || '') },
  fnCoordToDmsc = function () { return '' },
  fnGetAdminUrl = function () { return '' },
  windowRef = window
} = {}) {
  if (!layer || !layer.getLatLngs) return
  if (!$ || !areaSwal || !windowRef) return

  $(layer).off('click.portalPolygonCreate').on('click.portalPolygonCreate', function () {
    const draw = {}
    areaSwal.fire({
      showCancelButton: true,
      cancelButtonText: fnT('common.cancel'),
      confirmButtonText: fnT('common.save'),
      didOpen: function (modal) {
        const $cont = $(modal).find('.swal2-html-container').addClass('text-start')
        const points = { DMSc: [] }
        const flattenLatLngs = function (nodes, out) {
          if (!Array.isArray(nodes)) return
          nodes.forEach(function (node) {
            if (!node) return
            if (Array.isArray(node)) {
              flattenLatLngs(node, out)
            } else if (typeof node.lat === 'number' && typeof node.lng === 'number') {
              out.push(node)
            }
          })
        }
        const latLngs = []
        flattenLatLngs(layer.getLatLngs(), latLngs)
        latLngs.forEach(function (val) {
          points.DMSc.push([fnCoordToDmsc(val.lat, 'lat'), fnCoordToDmsc(val.lng, 'lon')].join(' '))
        })
        draw.DMSc = points.DMSc.join(' ')
        $cont.JSONView(draw, { collapsed: false })
      }
    }).then(function (result) {
      if (result.isConfirmed) {
        const url = String(fnGetAdminUrl() || '') + '/layers/create?cord_dmsc=' + draw.DMSc
        windowRef.open(url, '_blank').focus()
      }
    })
  })
}

const bindAltitudeUiHandlers = function ({
  $ = window.jQuery,
  $body = ($ ? $('body') : null),
  Swal = window.Swal,
  areaSwal = Swal,
  fnT = function (key) { return String(key || '') },
  fnBuildMapFunctionsPopupHtml = function () { return '' },
  fnGetMissionState = function () { return null },
  fnIsDemProviderEnabled = function () { return true },
  DEM_PROVIDER_PRIORITY = [],
  fnApplyAllDemProvidersToMissionPoints = function () {},
  fnApplyDemProviderToMissionPoints = function () {}
} = {}) {
  if (!$ || !$body || !Swal || !areaSwal) return
  const fnIsLocalProviderActive = function () {
    if (typeof window === 'undefined') return false
    const localState = window.PORTAL_LOCAL_TERRAIN_STATE
    return !!(
      localState &&
      localState.active === true &&
      (
        typeof localState.sampleElevation === 'function' ||
        typeof localState.sampleElevationAsync === 'function' ||
        typeof localState.sampleElevations === 'function'
      )
    )
  }
  const fnIsProviderAvailable = function (providerKey) {
    const key = String(providerKey || '').trim()
    if (!key) return false
    if (key === 'localDEM') return fnIsLocalProviderActive()
    return fnIsDemProviderEnabled(key)
  }
  const fnBuildEffectiveProviderKeys = function () {
    const out = fnIsLocalProviderActive() ? ['localDEM'] : []
    DEM_PROVIDER_PRIORITY.forEach((providerKey) => {
      const key = String(providerKey || '').trim()
      if (!key || out.includes(key)) return
      out.push(key)
    })
    return out
  }

  $body.find('[data-leaf-altitude]')
    .off('click.portalAltitude')
    .on('click.portalAltitude', function () {
      const missionState = fnGetMissionState()
      if (!missionState || !Array.isArray(missionState.waypoints) || !missionState.waypoints.length) {
        Swal.fire(fnT('altitude.no_processable_point'))
        return
      }
      const popupHtml = fnBuildMapFunctionsPopupHtml()
      if (!popupHtml) {
        Swal.fire(fnT('altitude.popup_template_missing'))
        return
      }
      areaSwal.fire({
        title: fnT('altitude.title'),
        size: 'lg',
        html: popupHtml,
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: fnT('common.cancel'),
        didOpen: function (modal) {
          const $modal = $(modal)
          $modal.find('[data-map-function-dem-provider]').each(function () {
            const providerKey = String($(this).data('mapFunctionDemProvider') || '').trim()
            if (fnIsProviderAvailable(providerKey)) return
            $(this).closest('.row').remove()
          })
          const enabledProviders = fnBuildEffectiveProviderKeys()
          if (!enabledProviders.length) {
            $modal.find('[data-map-function-dem-all]').prop('disabled', true).addClass('disabled')
          }
          $modal.find('[data-map-function-dem-all]').on('click', function () {
            if (!enabledProviders.length) return
            Swal.close()
            setTimeout(function () {
              void fnApplyAllDemProvidersToMissionPoints()
            }, 0)
          })
          $modal.find('[data-map-function-dem-provider]').on('click', function () {
            const providerKey = String($(this).data('map-function-dem-provider') || '').trim()
            Swal.close()
            setTimeout(function () {
              void fnApplyDemProviderToMissionPoints(providerKey)
            }, 0)
          })
        }
      })
    })
}

const bindQuickActionHandlers = function ({
  $body,
  fnHistoryUndo = function () {},
  fnHistoryRedo = function () {},
  fnOpenMapCursorElevationSettingsModal = function () {}
} = {}) {
  if (!$body || typeof $body.find !== 'function') return

  $body.find('[data-leaf-undo]')
    .off('click.portalQuickUndo')
    .on('click.portalQuickUndo', function () {
      fnHistoryUndo()
    })

  $body.find('[data-leaf-redo]')
    .off('click.portalQuickRedo')
    .on('click.portalQuickRedo', function () {
      fnHistoryRedo()
    })

  $body.find('[data-leaf-map-altitude-settings]')
    .off('click.portalQuickMapAltitudeSettings')
    .on('click.portalQuickMapAltitudeSettings', function () {
      fnOpenMapCursorElevationSettingsModal()
    })
}

const bindExternalLinkInterceptor = function ({
  $ = window.jQuery,
  $body = ($ ? $('body') : null),
  windowRef = window
} = {}) {
  if (!$ || !$body || !windowRef || typeof windowRef.open !== 'function') return

  $body
    .off('click.portalExternalLink', 'a')
    .on('click.portalExternalLink', 'a', function (event) {
      const $link = $(this)
      const url = String($link.attr('href') || '')
      if (!url) return
      if (!(url[0] === '/' && url[1] !== '/')) {
        // href="/where" ==> open here
        // href="//google.com" ==> open new window
        // href="tel:" ==> open new window
        // href="https://yandex.com" ==> open new window
        event.preventDefault()
        windowRef.open(url, '_blank').focus()
        return false
      }
    })
}

const bindBootstrapOverlayUiHandlers = function ({
  $ = window.jQuery,
  $body = ($ ? $('body') : null),
  ensureDropdown = function () { return null },
  ensureTooltip = function () { return null }
} = {}) {
  if (!$ || !$body) return

  $body
    .off('click.portalRuntimeDropdown', '[data-bs-toggle="dropdown"]')
    .on('click.portalRuntimeDropdown', '[data-bs-toggle="dropdown"]', function () {
      ensureDropdown(this)
    })

  $body
    .off('mouseenter.portalRuntimeTooltip focusin.portalRuntimeTooltip', '[data-bs-toggle="tooltip"]')
    .on('mouseenter.portalRuntimeTooltip focusin.portalRuntimeTooltip', '[data-bs-toggle="tooltip"]', function (event) {
      const instance = ensureTooltip(this)
      if (!instance) return
      // Dynamic elements (e.g. Swal content) need manual show on first interaction.
      if (event.type === 'mouseenter' || event.type === 'focusin') {
        instance.show()
      }
    })

  $body
    .off('mouseenter.portalRuntimeTooltipCleanup', '.tooltip')
    .on('mouseenter.portalRuntimeTooltipCleanup', '.tooltip', function () {
      const $current = $(this)
      $('.tooltip.bs-tooltip-auto').not($current).remove()
    })
}

const bindBeforeUnloadCleanupHandler = function ({
  windowRef = window,
  fnGetImportDraftPersistTimer = function () { return null },
  fnSetImportDraftPersistTimer = function () {},
  fnClearGeoTiffLayer = function () {},
  fnDropGeoTiffRuntimeCache = function () {},
  fnSetTiffLastFile = function () {}
} = {}) {
  if (!windowRef || typeof windowRef.addEventListener !== 'function') return
  if (windowRef.__portalBeforeUnloadCleanupBound) return
  windowRef.__portalBeforeUnloadCleanupBound = true

  windowRef.addEventListener('beforeunload', function () {
    const timer = fnGetImportDraftPersistTimer()
    if (timer) {
      clearTimeout(timer)
      fnSetImportDraftPersistTimer(null)
    }
    fnClearGeoTiffLayer()
    fnDropGeoTiffRuntimeCache()
    fnSetTiffLastFile(null)
  })
}

export {
  bindPolygonCreateClick,
  bindAltitudeUiHandlers,
  bindQuickActionHandlers,
  bindExternalLinkInterceptor,
  bindBootstrapOverlayUiHandlers,
  bindBeforeUnloadCleanupHandler
}
